/**
 * Tiny prefetch cache. When a product card is hovered (or scrolls into view
 * with high probability of being clicked), we proactively fetch the PDP JSON
 * so the click feels instantaneous.
 *
 * The actual page just reads from this cache on mount.
 */
import { api } from "@/lib/api";

const cache = new Map();
const inflight = new Map();

export function prefetchProduct(slug) {
  if (!slug) return;
  if (cache.has(slug) || inflight.has(slug)) return;
  const p = api
    .product(slug)
    .then((data) => {
      cache.set(slug, { data, at: Date.now() });
      inflight.delete(slug);
      return data;
    })
    .catch(() => inflight.delete(slug));
  inflight.set(slug, p);
}

export function readPrefetchedProduct(slug) {
  const entry = cache.get(slug);
  if (!entry) return null;
  // 60s freshness
  if (Date.now() - entry.at > 60_000) {
    cache.delete(slug);
    return null;
  }
  return entry.data;
}
